import { render, staticRenderFns } from "./index-property.vue?vue&type=template&id=48073633&scoped=true"
import script from "./index-property.vue?vue&type=script&lang=js"
export * from "./index-property.vue?vue&type=script&lang=js"
import style0 from "./index-property.vue?vue&type=style&index=0&id=48073633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48073633",
  null
  
)

export default component.exports